module.exports = __webpack_public_path__ + "img/143.9967fb79.jpg";